<template>
  <div class="address-pop-box show-flex-box-r" @click="closeSelectPop">
    <dl class="address-box show-flex-box-c" @click.stop="closeSelectArea">
      <dt class="show-flex-box-r">
        <!-- <span v-if="type=='newAdd'">新增收货地址</span> -->
        <span>修改地址</span>
      </dt>
      <dd class="address-info">
        <ul class="show-flex-box-c">
          <li class="show-flex-box-r">
            <span class="show-flex-box-r">收货人:</span>
            <strong>
              <input type="text" placeholder="请填写收货人姓名（必填）" v-model="addressInfo.accept_name">
            </strong>
          </li>
          <li class="show-flex-box-r">
            <span class="show-flex-box-r">手机号:</span>
            <strong>
              <input
                type="text"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                maxlength="11"
                placeholder="请填写手机号（必填）"
                v-model="addressInfo.mobile"
              >
            </strong>
          </li>
          <li class="show-flex-box-r area-selection">
            <span class="show-flex-box-r">所在区域:</span>
            <strong>
              <input
                type="text"
                placeholder="请选择省/市/区/街道（必填）"
                v-if="addressInfo.province"
                readonly
                v-model="addressInfo.province+' / '+addressInfo.city+' / '+addressInfo.area"
                @click.stop="showAreaSelect"
              >
              <input
                type="text"
                placeholder="请选择省/市/区/街道（必填）"
                v-else
                readonly
                @click.stop="showAreaSelect"
              >
              <strong @click.stop>
                <areaSelect v-if="isShow" @area_select="getLocation"></areaSelect>
              </strong>
              <span class="location" @click.stop="showAreaSelect"></span>
            </strong>
          </li>
          <li class="show-flex-box-r">
            <span class="show-flex-box-r">详细地址:</span>
            <strong>
              <textarea placeholder="请填写详细地址（必填）" v-model="addressInfo.address"></textarea>
            </strong>
          </li>
        </ul>
        <strong class="show-flex-box-r show-flex-center" @click.stop="saveAndClosePop">
          <span>保存</span>
        </strong>
      </dd>
    </dl>
  </div>
</template>

<script>
import areaSelect from "@/components/mars_box_store/common/area_select_cpn";
import regex from "@/filter/regex";

export default {
  name: "address_pop_cpn",
  data() {
    return {
      name: "",
      tel: "",
      location: "",
      home: "",
      isShow: false,
      addressCodeInfo: {}
    };
  },
  props: {
    addressInfo: [Object]
  },
  components: {
    areaSelect
  },
  methods: {
    closeSelectPop: function() {
      this.isShow = false;
      this.$emit("hide-address-pop");
    },
    closeSelectArea: function() {
      this.isShow = false;
    },
    saveAndClosePop: function() {
      if (regex.isEmpty(this.addressInfo.accept_name)) {
        this.$elementMsg.error({
          message: "请填写收货人",
          showClose: true,
          customClass: "pop-class-error",
          duration: 3000
        });
        return;
      }
      if (regex.isEmpty(this.addressInfo.mobile)) {
        this.$elementMsg.error({
          message: "请填写手机号",
          showClose: true,
          customClass: "pop-class-error",
          duration: 3000
        });
        return;
      }
      if (!regex.isPhoneNumber(this.addressInfo.mobile)) {
        this.$elementMsg.error({
          message: "请填写正确手机号",
          showClose: true,
          customClass: "pop-class-error",
          duration: 3000
        });
        return;
      }
      if (!this.addressCodeInfo.provinceCode && !this.addressCodeInfo.cityCode && !this.addressCodeInfo.areaCode) {
        this.$elementMsg.error({
          message: "请选择所在区域",
          showClose: true,
          customClass: "pop-class-error",
          duration: 3000
        });
        return;
      }
      if (regex.isEmpty(this.addressInfo.address)) {
        this.$elementMsg.error({
          message: "请填写详细地址",
          showClose: true,
          customClass: "pop-class-error",
          duration: 3000
        });
        return;
      }

      var params = {
        shipping_address_id: this.addressInfo.id,
        accept_name: this.addressInfo.accept_name,
        mobile: this.addressInfo.mobile,
        province: this.addressCodeInfo.provinceCode,
        city: this.addressCodeInfo.cityCode,
        area: this.addressCodeInfo.areaCode,
        post_code: this.addressCodeInfo.streetCode,
        address: this.addressInfo.address
      };
      //this.$loading({fullscreen: true,background: 'rgba(0,0,0,0.5)',lock: true,text: '拼命加载中...'})；
      this.$client
        .addNewAddress(params)
        .then(res => {
          if (res.code == 200 || res.code == "200") {
            // this.$loading().close();
            this.$elementMsg.success({
              message: "修改地址成功",
              showClose: true,
              customClass: "pop-class-success",
              duration: 3000
            });

            var addressSuccess = {
              status: false,
              refresh: true
            };
            this.$emit("close-select-address", addressSuccess);
          }
        })
        .catch(err => {
          // this.$loading().close();
          if (err.message) {
            this.$elementMsg.error({
              message: err.message,
              showClose: true,
              customClass: "pop-class-error",
              duration: 3000
            });
          } else {
            this.$elementMsg.error({
              message: "网络错误，请稍后重试",
              showClose: true,
              customClass: "pop-class-error",
              duration: 3000
            });
          }
        });
    },
    showAreaSelect: function() {
      this.isShow = true;
    },
    getLocation: function(value, obj) {
      this.isShow = false;
      this.addressInfo.province = value.province;
      this.addressInfo.city = value.city;
      this.addressInfo.area = value.area;
      this.addressInfo.atreet = value.atreet;
      this.addressCodeInfo = obj;
    }
  }
};
</script>

<style lang="less" scoped>
//公共字体样式  start
.user-register-font-style( @size; @weight; @height; @color ) {
  display: block;
  font-size: @size;
  font-weight: @weight;
  line-height: @height;
  color: @color;
  word-break: break-all;
}

.address-pop-box {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  outline: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  justify-content: center;
  z-index: 999;
  & > .address-box {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 861px;
    height: 521px;
    background: #fff;
    border-radius: 10px;
    & > dt {
      align-items: center;
      padding-left: 41px;
      height: 50px;
      border-bottom: 1px solid #e6e6e6;
      & > span {
        font-size: 18px;
        font-family: PingFang-SC-Medium;
        font-weight: 500;
        color: #191d21;
      }
    }
    & > .address-info {
      padding-top: 40px;
      & > ul {
        & > li {
          padding-bottom: 20px;
          & > span {
            justify-content: flex-end;
            align-items: center;
            width: 218px;
            height: 40px;
            font-size: 18px;
            font-family: PingFang-SC-Medium;
            font-weight: 500;
            color: #191d21;
            margin-right: 20px;
            text-align: right;
          }
          & > strong {
            cursor: pointer;
            position: relative;
            width: 450px;
            height: 40px;
            & > strong {
              display: block;
              width: 100%;
            }
            & > .location {
              cursor: pointer;
              display: block;
              position: absolute;
              right: 21px;
              top: 15px;
              width: 14px;
              height: 8px;
              background: url("../../assets/common/select_area_icon.png")
                no-repeat center center;
              background-size: cover;
            }
            & > input {
              width: 428px;
              padding-left: 20px;
              height: 38px;
              background: #fafafa;
              border-radius: 5px;
              border: 1px solid #e6e6e6;
              color: #191d21;
              font-size: 16px;
              font-weight: 500;
            }
            & > input::placeholder {
              font-size: 16px;
              font-family: PingFang-SC-Regular;
              font-weight: 400;
              color: #808080;
            }
            & > textarea {
              resize: none;
              padding-left: 20px;
              padding-top: 13px;
              width: 426px;
              height: 103px;
              background: #fafafa;
              border-radius: 5px;
              border: 1px solid #e6e6e6;
              color: #191d21;
              font-size: 16px;
              font-weight: 500;
            }
            & > textarea::placeholder {
              font-size: 16px;
              font-family: PingFang-SC-Regular;
              font-weight: 400;
              color: #808080;
              line-height: normal;
            }
          }
        }
        & > li:last-child {
          height: 120px;
        }
        & > .area-selection {
          z-index: 999;
          & > strong {
            & > input {
              cursor: pointer;
            }
          }
        }
      }
      & > strong {
        cursor: pointer;
        width: 140px;
        height: 40px;
        background: #ff7800;
        border-radius: 5px;
        margin-left: 238px;
        & > span {
          font-size: 18px;
          font-family: PingFang-SC-Medium;
          font-weight: 500;
          color: #fff;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/mars_box_store/address_pop_cpn.vue